import React from "react";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Adimayiruthal() {
    const { t } = useTranslation();
    return (
        <div style={{ marginBottom: '100px' }}>
            <div className="row banner" style={{ display:'flex',alignItems:'center',justifyContent:'center',background:'orange', backgroundSize: 'cover', backgroundPosition: 'center',height:'400px' }}>
      <img src="./images/maruthi.png" alt="image" style={{width:'20%'}} />
      </div>
            <div class="container">
                <div
                    className="container animated-border"
                    style={{
                        marginTop: '50px',
                        marginBottom: '50px',
                        background: 'white',
                        borderRadius: '15px'
                    }}
                >
                    <div className="row">
                        <div
                            className="col-12 col-md-5"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '25px'
                            }}
                        >
                            <img
                                src="./images/hanuman-01.png"
                                alt="Maruthi Temple"
                                style={{ width: '100%' }}
                            />
                        </div>

                        <div
                            className="col-12 col-md-7"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}

                        >
                            <h3 className="hheading" style={{ paddingLeft: '50px', paddingTop: '50px' }}> {t("adima-head")}</h3>
                            <p className="about">
                            {t("adima-p1")} <br />
                            {t("adima-p2")}<br />
                            {t("adima-p3")}

                            </p>
                        </div>
                    </div>
                </div>




                


            </div>

        </div>
    );
}

export default Adimayiruthal;
